<script setup>
import { computed } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay } from "swiper";
import "swiper/css";
import ResponsiveImage from "@/components/Image/ResponsiveImage.vue";
import { useSwiperInstance } from "@/util/useSwiperInstance.ts";

const { setSwiperInstance } = useSwiperInstance();

const props = defineProps({
  sponsorMedia: {
    type: Array,
    default: () => [],
  },
});

const slidesPerView = computed(() =>
  props.sponsorMedia.length < 4 ? props.sponsorMedia.length : 4
);

const loop = computed(() => props.sponsorMedia.length > 4);
</script>

<template>
  <Swiper
    :slides-per-view
    :modules="[Autoplay]"
    :space-between="20"
    :loop
    :autoplay="{
      delay: 5000,
      disableOnInteraction: false,
    }"
    class="sponsor-bar-carousel"
    data-testid="sponsor-bar-carousel"
    @swiper="setSwiperInstance"
  >
    <SwiperSlide
      v-for="slide in sponsorMedia"
      :key="slide"
      class="sponsor-bar-carousel__swiper"
    >
      <ResponsiveImage
        class="sponsor-bar-carousel__image"
        :src="slide.url"
        :alt="slide?.metadata?.description ?? 'Logo belonging to a sponsor'"
        sizes="(min-width: 768px) 25vw, 50vw"
      />
    </SwiperSlide>
  </Swiper>
</template>

<style scoped lang="scss">
@import "@/v2/styles/main";

.sponsor-bar-carousel {
  width: 100%;
  height: 100%;
  display: flex;

  &__swiper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__image {
    max-width: 60px;
    max-height: 40px;
    object-fit: contain;

    @include min-width-sm {
      display: block;
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
